// TextField.tsx
import React, { ChangeEvent } from 'react';
import styles from './TextField.module.css';
import { toTurkishUpperCase } from '../../../utils/stringUtils';

interface TextFieldProps {
  name: string;
  value: string | number;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  type?: string;
  placeholder?: string;
  error?: string;
  className?: string;
  disableUppercase?: boolean;
}

export const TextField: React.FC<TextFieldProps> = ({
  name,
  value,
  onChange,
  label,
  type = 'text',
  placeholder,
  error,
  className,
  disableUppercase = false,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const upperValue =
      disableUppercase || type === 'password' || type === 'email' || type === 'number'
        ? inputValue
        : toTurkishUpperCase(inputValue);

    const syntheticEvent = {
      ...e,
      target: {
        ...e.target,
        value: upperValue,
      },
    } as ChangeEvent<HTMLInputElement>;

    onChange(syntheticEvent);
  };

  return (
    <div className={styles.container}>
      {label && (
        <label htmlFor={name} className={styles.label}>
          {label}
        </label>
      )}
      <input
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className={`${styles.input} ${error ? styles.error : ''} ${className || ''}`}
      />
      {error && <span className={styles.errorMessage}>{error}</span>}
    </div>
  );
};
